import { render, staticRenderFns } from "./Directive.vue?vue&type=template&id=148fb9e0&scoped=true&"
import script from "./Directive.vue?vue&type=script&lang=js&"
export * from "./Directive.vue?vue&type=script&lang=js&"
import style0 from "./Directive.vue?vue&type=style&index=0&id=148fb9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148fb9e0",
  null
  
)

export default component.exports